export const TRANSLATIONS = {
  ADMIN_PLACEHOLDER: 'View as',
  CUSTOMER_PLACEHOLDER: 'Select publisher',
  SELECT_ALL: 'Select all',
}
